import React from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { WarningIconBig } from 'components/common/icons';
import { Button, Col, FMGModal, Row, Typography } from 'components';
import { usePreCreateCheckModal } from './usePreCreateCheckModal';

export type PreCheckMessageType = 'MESSAGE_1' | 'MESSAGE_2' | 'MESSAGE_3' | 'FOLLOW_UP_FAILED';

export interface IPreCreateCheckModal {
  modalState: boolean;
  onModalStateChange: () => void;
  preCheckMessage: PreCheckMessageType | undefined;
  onContinue: () => void;
  purchaseOrderItemIds: React.Key[];
}

export const PreCreateCheckModal = (props: IPreCreateCheckModal) => {
  const { modalState, onModalStateChange, preCheckMessage, onContinue, purchaseOrderItemIds } = props;
  const { onCancel, message, handleContinue, onFollowUp, clientOrders, isFollowUpFailed, followUpIsLoading } =
    usePreCreateCheckModal({
      onModalStateChange,
      modalState,
      preCheckMessage,
      onContinue,
      purchaseOrderItemIds,
    });
  return (
    <FMGModal
      width={360}
      onCancel={onCancel}
      onClose={onCancel}
      open={modalState}
      footer={() => {
        if (isFollowUpFailed) {
          return (
            <Button block={true} type="primary" size={'large'} onClick={onCancel}>
              Okay
            </Button>
          );
        } else if (preCheckMessage === 'MESSAGE_1') {
          return (
            <Row wrap={false} align={'middle'} className={'gap-8 margin-t-24'}>
              <Button block={true} type={'primary'} ghost size={'large'} onClick={onCancel}>
                Cancel
              </Button>
              <Button block={true} type="primary" size={'large'} onClick={handleContinue}>
                Continue
              </Button>
            </Row>
          );
        } else {
          return (
            <Row align={'middle'} gutter={[0, 8]} className={'margin-t-24'}>
              <Col span={24}>
                <Row align={'middle'} wrap={false} className={'gap-8'}>
                  <Button block={true} type={'primary'} size={'large'} onClick={handleContinue}>
                    Continue
                  </Button>
                  <Button block={true} type="primary" size={'large'} onClick={onFollowUp} loading={followUpIsLoading}>
                    Follow-Up
                  </Button>
                </Row>
              </Col>
              <Col span={24}>
                <Button block={true} type={'primary'} ghost size={'large'} onClick={onCancel}>
                  Cancel
                </Button>
              </Col>
            </Row>
          );
        }
      }}
    >
      <Row justify="center" gutter={[0, 12]} className={'margin-t-20'}>
        {isFollowUpFailed && <WarningIconBig />}
        <Col span={24} className={'center'}>
          <Typography.Title className={'reset-title font-weight-800'} level={3}>
            {message.title}
          </Typography.Title>
        </Col>
        <Col span={24} className={'center'}>
          <Row>
            <Col span={24}>
              <Typography.Text type={'secondary'}>{message.description}</Typography.Text>
            </Col>
            <Col span={24} className={'center'}>
              {isFollowUpFailed &&
                clientOrders?.map((order, index) => (
                  <React.Fragment key={order.id}>
                    <Link to={`${ADMIN_ROUTES.orders.view}/${order.id}/general`} target="_blank">
                      <Typography.Text underline type="secondary" ellipsis={{ tooltip: true }}>
                        {order.uuid}
                      </Typography.Text>
                    </Link>
                    {index < clientOrders.length - 1 && ', '}
                  </React.Fragment>
                ))}
            </Col>
          </Row>
        </Col>
      </Row>
    </FMGModal>
  );
};
